import React from 'react';
import { Zap, MessageCircle, Bell } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';

const OrdersAutoAcceptModal = ({ autoAcceptMessage, autoAcceptSendWhatsApp, autoAcceptNewOrderSound, setAutoAcceptNewOrderSound, saveAutoAcceptSettings, savingAutoAcceptSettings, setAutoAcceptMessage, setAutoAcceptSendWhatsApp, setShowAutoAcceptSettings, showAutoAcceptSettings }) => {
  return (
      <Dialog open={showAutoAcceptSettings} onOpenChange={setShowAutoAcceptSettings}>
        <DialogContent className="bg-gray-900 border border-gray-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-lg">
              <Zap className="text-emerald-400" size={20} />
              Configurar Auto-Aceitar
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-5 pt-2">
            <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border border-gray-700">
              <div className="flex items-center gap-3">
                <MessageCircle className="text-green-400" size={20} />
                <div>
                  <p className="text-white text-sm font-medium">Enviar WhatsApp</p>
                  <p className="text-gray-400 text-xs">Notificar cliente quando pedido for aceito</p>
                </div>
              </div>
              <button
                onClick={() => setAutoAcceptSendWhatsApp(!autoAcceptSendWhatsApp)}
                className={`relative w-11 h-6 rounded-full transition-colors ${autoAcceptSendWhatsApp ? 'bg-green-500' : 'bg-gray-600'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${autoAcceptSendWhatsApp ? 'left-6' : 'left-1'}`} />
              </button>
            </div>

            <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border border-gray-700">
              <div className="flex items-center gap-3">
                <Bell className="text-amber-400" size={20} />
                <div>
                  <p className="text-white text-sm font-medium">Som de pedido novo</p>
                  <p className="text-gray-400 text-xs">Tocar o som da loja uma vez quando entrar um pedido novo</p>
                </div>
              </div>
              <button
                onClick={() => setAutoAcceptNewOrderSound(!autoAcceptNewOrderSound)}
                className={`relative w-11 h-6 rounded-full transition-colors ${autoAcceptNewOrderSound ? 'bg-green-500' : 'bg-gray-600'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${autoAcceptNewOrderSound ? 'left-6' : 'left-1'}`} />
              </button>
            </div>
            
            <div className={`space-y-2 ${!autoAcceptSendWhatsApp ? 'opacity-50 pointer-events-none' : ''}`}>
              <label className="block text-sm text-gray-300">Mensagem de confirmação</label>
              <textarea
                value={autoAcceptMessage}
                onChange={(e) => setAutoAcceptMessage(e.target.value)}
                className="w-full bg-gray-800 border border-gray-600 rounded-lg px-3 py-2 text-white text-sm resize-none focus:border-emerald-500 focus:outline-none"
                rows={3}
                placeholder="Seu pedido foi recebido e já está em produção! 🍕"
              />
              <p className="text-xs text-gray-500">
                Use <span className="text-emerald-400">{'{nome}'}</span> para nome do cliente, <span className="text-emerald-400">{'{pedido}'}</span> para número do pedido
              </p>
            </div>
            
            {autoAcceptSendWhatsApp && (
              <div className="p-3 bg-gray-800/30 rounded-lg border border-gray-700/50">
                <p className="text-xs text-gray-500 mb-2">Preview da mensagem:</p>
                <p className="text-sm text-gray-300 italic">
                  &quot;{autoAcceptMessage.replace('{nome}', 'João').replace('{pedido}', '#WEB123').replace('{loja}', 'Sua Loja')}&quot;
                </p>
              </div>
            )}
            
            <div className="flex gap-3 pt-2">
              <button
                onClick={() => setShowAutoAcceptSettings(false)}
                className="flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors text-sm"
              >
                Cancelar
              </button>
              <button
                onClick={saveAutoAcceptSettings}
                disabled={savingAutoAcceptSettings}
                className="flex-1 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-gray-600 text-white rounded-lg transition-colors text-sm flex items-center justify-center gap-2"
              >
                {savingAutoAcceptSettings ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
  );
};

export default OrdersAutoAcceptModal;
